import axios from 'axios';

export const fetchCustomerOrder = async (token) => {
  try {
    const data = JSON.stringify({
      query: `query {
        salesOrder(currentPage: 1, pageSize: 100)  {
          salesData {
            created_at
            customer_name
            grand_total
            increment_id
            shipping_method
            shipping_carrier {
              title
              tracking_number
              __typename
            }
            billing {
              city
              company
              country
              fax
              name
              postcode
              region
              street
              telephone
              __typename
            }
            shipping {
              city
              company
              country
              fax
              name
              postcode
              region
              street
              telephone
              __typename
            }
            items {
              item_id
              image_url
              price
              sku
              title
              product_options
              promowallet_item_level
              candere_360_invoice_file_path
              can_return
              rma_status
              __typename
            }
            totals {
              entity_id
              status
              coupon_code
              total_paid
              base_discount_amount
              base_grand_total
              base_subtotal
              base_subtotal_incl_tax
              base_tax_amount
              base_total_due
              increment_id
              discount_amount
              grand_total
              subtotal
              subtotal_incl_tax
              tax_amount
              total_due
              shipping_method
              weight
              payment_method
              payment_title
              insurance
               __typename
              }
              __typename
            }
            total_count
            page_info {
              current_page
              page_size
              total_pages
            }
            __typename
          }
        }
        `
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://mcstaging.candere.com/graphql',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      withCredentials: true,
      data: data
    };

    const response = await axios.request(config);
    return response.data;

  } catch (error) {
    console.error("Failed to fetch sales order:", error);
    return null;
  }
};